// src/index.ts
import Menu from "./components/menu";
import { Accordion } from "./components/accordion";
import 'flexslider';
import SimpleLightbox from "simplelightbox";
// ---- neu: unser Mobile-Menu Script importieren ----
import "./components/mobile-menu"; // Pfad ggf. anpassen, je nachdem wo die Datei liegt
const mobileMenu = $("#mobile-menu");
const mobileMenuButton = $("#mobile-menu-button");
let menu = new Menu(mobileMenu, mobileMenuButton);
menu.setListeners();
let accordion = new Accordion();
$(document).ready(function () {
    $('.flexslider').flexslider({
        animation: "slide",
        customDirectionNav: $(".custom-navigation a"),
        slideshow: true,
        slideshowSpeed: 5000,
        animationSpeed: 800,
        touch: true,
        animationLoop: true,
    });
});
document.addEventListener("DOMContentLoaded", function () {
    new SimpleLightbox('.simple-lightbox a', {
        /* Optionen hier */
        captionsData: 'alt',
        captionDelay: 250,
    });
});
